export const SITE = {
  company: 'Cespedis Property Management & Commercial Leasing',
  short: 'Cespedis',
  tagline: 'Your Growth, Our Commitment.',
  longTagline: 'Maximizing Occupancy. Enhancing Asset Value. Creating Long-Term Success.',
  address: '2nd Floor, EFC SPRINT, H07, Phoenix Avance Business Hub, Gachibowli, Hyderabad - 500032',
  phone: '+91 7097857454',
  phoneTel: '+917097857454',
  email: 'info@cespedis.com',
  hours: 'Mon – Sat, 10:00 AM – 7:00 PM',
  logo: { nav: '/brand/cespedis-logo-nav.png', md: '/brand/cespedis-logo-md.png', lg: '/brand/cespedis-logo-lg.png' },
  socials: {
    linkedin: 'https://www.linkedin.com/company/cespedis-commercial-leasing/',
    instagram: 'https://www.instagram.com/cespedis_corp?igsh=dWF1bjFrNHQ0eXRx&utm_source=qr',
    facebook: 'https://www.facebook.com/profile.php?id=61591203872870&mibextid=wwXIfr&mibextid=wwXIfr'
  }
};

export const NAV = [
  { label: 'Home', href: '/' },
  { label: 'About', href: '/about' },
  { label: 'Services', href: '/services' },
  { label: 'Properties', href: '/properties' },
  { label: 'Blog', href: '/blog' },
  { label: 'Contact', href: '/contact' },
];
